import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeSubscribeService {

  constructor() { }
  
  private themeSubject = new Subject<string>();

  public receiveTheme(theme: string): void {
    this.themeSubject.next(theme);
  }

  public getObservable(): Observable<string> {
    return this.themeSubject.asObservable();
  }
}
